export default __webpack_public_path__ + "static/ghost_shocked-8d9d669402bc1158b7954388d039babb.svg";